<template>
  <div id="app">
    <app-layout></app-layout>
  </div>
</template>
<script>
import AppLayout from "./layout/index";
export default {
  components: {
    AppLayout,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* min-width: 1899px; */
    overflow-x: auto;
  overflow-y: hidden;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
* {
  margin: 0;
  padding: 0;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
</style>
